import React, { useState } from "react";
import "./Page.css";
import extensionImg from "../assets/extensions/auto-review.png";

const API = "https://govindam-zg2i.onrender.com";
const RAZORPAY_KEY = "rzp_live_SJXAZk8V3WlfJR";

const AppsExtensions = () => {
  const [showModal, setShowModal] = useState(false);
  const [showGuide, setShowGuide] = useState(false);   // NEW
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    otp: ""
  });

  /* ================= Load Razorpay ================= */
  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  /* ================= Send OTP ================= */
  const sendOtp = async () => {
    if (!formData.name || !formData.email) {
      alert("Enter name and email");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(API + "/send-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: formData.email.toLowerCase()
        })
      });

      const data = await res.json();

      if (data.success) {
        alert("OTP sent to your email");
        setOtpSent(true);
      } else {
        alert(data.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }

    setLoading(false);
  };

  /* ================= Verify OTP + Payment ================= */
  const handlePayment = async () => {
    if (!formData.otp) {
      alert("Enter OTP");
      return;
    }

    setLoading(true);

    try {
      const otpRes = await fetch(API + "/verify-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formData.email.toLowerCase(),
          otp: formData.otp
        })
      });

      const otpData = await otpRes.json();

      if (otpData.valid !== true) {
        alert("Invalid OTP");
        setLoading(false);
        return;
      }

      const loaded = await loadRazorpay();
      if (!loaded) {
        alert("Failed to load Razorpay");
        setLoading(false);
        return;
      }

      const orderRes = await fetch(API + "/create-order", {
        method: "POST"
      });

      const orderData = await orderRes.json();

      if (!orderData.success) {
        alert("Order creation failed");
        setLoading(false);
        return;
      }

      const options = {
        key: RAZORPAY_KEY,
        amount: orderData.amount,
        currency: "INR",
        name: "Govindam",
        description: "FK Auto Review Finder - 1 Month",
        order_id: orderData.orderId,

        prefill: {
          name: formData.name,
          email: formData.email
        },

        handler: async function (response) {
          await fetch(API + "/verify-payment", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              name: formData.name,
              email: formData.email.toLowerCase(),
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature
            })
          });

          alert("Payment successful!");
          setShowModal(false);
          setOtpSent(false);
          setLoading(false);
        }
      };

      new window.Razorpay(options).open();

    } catch (err) {
      console.error(err);
      alert("Payment error");
      setLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div className="apps-page">
      <div className="extension-card">
        <img
          src={extensionImg}
          alt="FK Auto Review Finder"
          className="extension-icon"
        />

        <h3>FK Auto Review Finder</h3>

<div className="extension-hover">
  <p>
    Automatically fetches product reviews.<br />
    Valid for 1 month.
  </p>

  <button onClick={() => setShowGuide(true)}>
    How to use?
  </button>

  <button onClick={() => setShowModal(true)}>
    Buy ₹29 / Month
  </button>
</div>
      </div>

      {/* ================= BUY MODAL ================= */}
      {showModal && (
        <div className="modal-bg">
          <div className="modal-box">
            <h2>Buy Extension</h2>

            <input
              type="text"
              placeholder="Name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />

            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />

            {!otpSent && (
              <button disabled={loading} onClick={sendOtp}>
                {loading ? "Sending..." : "Send OTP"}
              </button>
            )}

            {otpSent && (
              <>
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={formData.otp}
                  onChange={(e) =>
                    setFormData({ ...formData, otp: e.target.value })
                  }
                />

                <button disabled={loading} onClick={handlePayment}>
                  {loading ? "Processing..." : "Verify OTP & Pay ₹29"}
                </button>
              </>
            )}

            <button
              className="close-btn"
              onClick={() => {
                setShowModal(false);
                setOtpSent(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* ================= HOW TO USE MODAL ================= */}
      {showGuide && (
        <div className="modal-bg">
          <div className="modal-box" style={{ maxWidth: "420px", textAlign: "left" }}>
            <h2 style={{ textAlign: "center" }}>How to use</h2>

            <p><b>Solution for flipkart reviews in desktop or android 🔥</b></p>
            <p><i>Disclaimer - Product needs to have minimum of 10+ reviews</i></p>

            <p>Step 1 - Download Firefox</p>
            <a href="https://play.google.com/store/apps/details?id=org.mozilla.firefox" target="_blank" rel="noreferrer">
              Open Firefox
            </a>

            <p>Step 2 - Install Extension</p>
            <a href="https://addons.mozilla.org/en-US/firefox/addon/flipkart-auto-review-finder" target="_blank" rel="noreferrer">
              Open Extension Page
            </a>

            <p>Step 3 - Always use desktop mode in browser</p>
            <p>Step 4 - Copy the product page link</p>
            <p>Step 5 - Tap on “View all reviews”</p>
            <p>Step 6 - Find your review and click Permalink</p>

            <p style={{ textAlign: "center", marginTop: "10px", fontWeight: "bold" }}>
              All the best guys ✅
            </p>

            <button className="close-btn" onClick={() => setShowGuide(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppsExtensions;